import gql from "graphql-tag";

export const GET_CORE_CONFIG_DATA = gql`
	query GetCoreConfiguration {
		GetCoreConfiguration {
			coverageApprovalTypeIds
		}
	}
`;
